module.exports = __webpack_public_path__ + "img/newsBj.48502e09.png";